// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__10mgU","content":"ManualTimeModal_content__2261n"};